export const getQueryParams = (value) => {
	const queryParams = new URLSearchParams(window.location.search);
	return queryParams.get(value)
}
